<script setup lang="ts">
  useHead({
    link: [
      {
        rel: 'preload',
        as: 'image',
        href: '/images/lo-hp-new/hero-sm@1x.webp',
        imagesrcset: '/images/lo-hp-new/hero-sm@1x.webp 1x, /images/lo-hp-new/hero-sm@2x.webp 2x',
        imagesizes: '50vw',
        media: '(max-width: 768px)',
        fetchpriority: 'high',
      },
    ],
  });
</script>

<template>
  <img
    class="absolute inset-0 z-0 w-full"
    alt="FACE FORMER HEAVYWEIGHT CHAMPION ANDY RUIZ JR. AND WIN BIG!"
    srcset="/images/lo-hp-new/hero-sm@1x.webp 1x, /images/lo-hp-new/hero-sm@2x.webp 2x"
    src="/images/lo-hp-new/hero-sm@1x.webp"
    fetchpriority="high"
    sizes="100vw"
  />
  <div
    class="flex flex-col items-center justify-between absolute inset-0 z-10 px-4 pt-[clamp(1.5rem,6.5vw,3.25rem)] pb-[clamp(2.5rem,10vw,4rem)]"
  >
    <div>
      <h2
        class="text-[clamp(1.5rem,6.25vw,2.25rem)] italic font-extrabold leading-none text-shadow-[var(--shadow-small)] mb-0.5"
      >
        PLAY ORIGINAL PvP GAMES
      </h2>
      <p
        class="flex items-center gap-2 text-[clamp(1.5rem,6.25vw,2.25rem)] italic font-extrabold leading-none text-shadow-[var(--shadow-small)]"
      >
        TO
        <b class="text-[#5BB5FA] text-[clamp(2.3125rem,9.75vw,3.125rem)] italic font-black leading-none">
          WIN REAL CASH
        </b>
      </p>
    </div>
    <div>
      <p class="text-[clamp(1.0625rem,4.5vw,2.125rem)] font-extrabold leading-none text-shadow-[var(--shadow-small)]">
        FACE FORMER HEAVYWEIGHT CHAMPION
      </p>
      <p
        class="text-[clamp(1.3125rem,5.5vw,2.625rem)] font-extrabold leading-none text-shadow-[var(--shadow-small)] mb-6"
      >
        <span class="text-[#5BB5FA] italic font-black">ANDY RUIZ JR.</span>
        AND WIN BIG
      </p>
      <CoreButton color="green" class="min-w-52 h-13 px-8 py-4 justify-center items-center">
        <span class="font-inter text-base font-extrabold leading-none tracking-[0.16px] uppercase">PLAY NOW</span>
      </CoreButton>
    </div>
  </div>
</template>
